import { INVALID_VALIDATOR } from 'constants/errors';
import { DNK, NO } from 'constants/values';
import {
  BranchCollectionModel,
  BranchCollectionItemModel,
  ValidateErrorContext,
} from 'forms/shared/types';
import { isPVQForm } from 'helpers/form';
import { BaseCustomValidator } from '../types';
import { EmptyBranchCollectionInstance } from '../../models/branchCollection/instance';
import branchCollectionModelValidator from '../../models/branchCollection';
import branchCollectionItemModelValidator from '../../models/branchCollectionItem';
import { EmptyBranch } from '../../models/branch/instance';

const branchCollectionBaseValidator: BaseCustomValidator<BranchCollectionModel<
  BranchCollectionItemModel
>> = (validateModel) => function (value, options, key, attributes, globalOptions) {
  const { items } = { ...EmptyBranchCollectionInstance, ...value };
  const { validator } = options;

  if (!validator) { return INVALID_VALIDATOR; }
  let itemsErrors: ValidateErrorContext[] = [];

  const branchCollectionModelErrors = validateModel(value, branchCollectionModelValidator, options);
  if (typeof branchCollectionModelErrors !== 'boolean') { itemsErrors = [...branchCollectionModelErrors]; }

  const data = [...items];

  // Branch Collection produces an additional item (even though it isn't used)
  // to show "Do you have another item to add". When it is left unchecked, it
  // won't generate any data, but we still need to validate it. The below will
  // generate data for it (for the purpose of validation).
  if (data.length === 0 || data[data.length - 1]?.Item.Has?.value === 'Yes') {
    data.push({
      Item: {
        Has: EmptyBranch(),
      },
    });
  }

  data.forEach((item, index) => {
    const branchCollectionItemModelErrors = validateModel(
      { ...item.Item, $index: index },
      branchCollectionItemModelValidator,
      options
    );

    if (typeof branchCollectionItemModelErrors !== 'boolean') { itemsErrors = [...itemsErrors, ...branchCollectionItemModelErrors]; }

    if (item.Item.Has?.value === NO || (isPVQForm(globalOptions?.formType) && item.Item.Has?.value === DNK)) {
      // Branch collections generate an additional item. Thus, when "Has" is
      // equal to "No", it won't validate that item.
      return;
    }

    const errors = validateModel({ ...item.Item, $index: index }, validator, {
      ...globalOptions,
      ...options,
    });
    if (typeof errors !== 'boolean') {
      itemsErrors = [...itemsErrors, ...errors];
    }
  });

  return itemsErrors.length ? itemsErrors : null;
};

export default branchCollectionBaseValidator;
